import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2370">
      <div className="dark" data-id="element-2371">
        <Hero data-id="element-2372" />
      </div>
      <WhyUs data-id="element-2373" />
      <ByTheNumbers data-id="element-2374" />
      <Services data-id="element-2375" />
      <HowItWorks data-id="element-2376" />
      <FAQ data-id="element-2377" />
      <Reviews data-id="element-2378" />
      <CtaBanner data-id="element-2379" />
    </main>;
}